import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { actionShopUpdateShiftLevel } from "../actionShop";
export var epicShopInitialShiftLevelRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.Received), mapTo(actionShopUpdateShiftLevel()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/epics/epicShopInitialShiftLevelRequest.ts
// module id = 2337
// module chunks = 3